import { useEffect } from 'react';
import { pageTitle } from './head';

/** Keep document.title in step with the <title> the generator wrote. */
export default function useSeoDocumentTitle(type, payload) {
  useEffect(() => {
    if (typeof document !== 'undefined') document.title = pageTitle(type, payload);
  }, [type, payload]);
}
